export const USER_WAITLISTED_ITEMS = 'user waitlisted items';
